import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RequestStateModel } from '../models/request_state_model';
import { ISection } from '../../interfaces/scheduler_interfaces';

/**
 * @description Command to set the request state of a scheduled section
 * A scheduled section can be in a pending state for Unschedule Course, Drop Course,
 * Remove from Waitlist, Withdraw Course
 */

export type ScheduledSectionRequestStateCommand = (
  sectionId: ISection['id'][],
  isRequestPending: boolean
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'scheduledSectionRequestStateCommand',
    function scheduledSectionRequestStateCommand(
      defineCommandORM: IDefineCommand,
      ngRequestStateModel: RequestStateModel
    ) {
      'use strict';

      return defineCommandORM(
        'scheduledSectionRequestStateCommand',
        (deferred, sectionIds: ISection['id'][], isRequestPending: boolean) => {
          const scheduledSectionPendingSet = ngRequestStateModel.read().scheduledSectionPendingSet;
          if (isRequestPending) {
            sectionIds.forEach((sectionId) => scheduledSectionPendingSet.add(sectionId));
          } else {
            sectionIds.forEach((sectionId) => scheduledSectionPendingSet.delete(sectionId));
          }
          ngRequestStateModel.write({ scheduledSectionPendingSet: scheduledSectionPendingSet });
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/request_state/commands/scheduled_section_request_state_command.ts